<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template #activator="scope">
      <v-btn v-if="user == null"
        fab x-small rounded dark class="ml-2"
        v-on="scope.on" color="primary"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>

      <activator-button v-else :scope="scope" />
    </template>

    <v-form ref="form" @submit.prevent="submitClick" autocomplete="off">
      <v-card>
        <v-card-title style="background-color: #004056" class="white--text">
          {{ user ? 'Edit' : 'Add' }} User
        </v-card-title>

        <v-divider/>

        <v-card-text>
          <v-text-field
            ref="email_field"
            outlined dense
            :disabled="user"
            :rules="[required ]"
            v-model="email"
            label="Email Address"
            validate-on-blur
          />
          <v-text-field
            outlined dense
            :rules="[required]"
            v-model="name"
            label="Name"
            validate-on-blur
            @input="onUpdateName"
          />
          <v-text-field
            outlined dense
            :rules="[required]"
            v-model="display_name"
            label="Display Name"
            validate-on-blur
            @blur="onDisplayNameBlur"
          />
          <v-select 
            outlined dense hide-details="auto"
            :rules="[change_personal_role]"
            v-model="role"
            label="User Type"
            :items="[{ text: 'User', value: 'user' }, { text:'Admin', value: 'admin' }]"
          />
        </v-card-text>

        <template v-if="!user">
          <v-divider />
          <div class="px-4 py-2" style="font-size: 12px">
            Creating this user will send a welcome invitation to their email, allowing them
            to claim and verify their account.
          </div>
        </template>

        <v-divider />

        <v-card-actions class="justify-center py-3">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <ErrorOverlay
      title="Error Updating User"
      v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { ActivatorButton } from '@/components/pages'
  import { required } from '@/lib/validations'
  import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

  export default {
    name: 'UserDialog',

    mixins: [ ErrorOverlayMixin ],

    props: ['user'],

    components: { ActivatorButton },

    data() {
      return {
        dialogVisible: false,

        user_id: -1,
        name: '',
        display_name: '',
        email: '',
        phone: '',
        role: 'user',

        // validation rules
        required,
      }
    },

    computed: {
      ...mapGetters('auth', ['me']),

      change_personal_role() {
        const that = this
        return v => {
          if (that.user_id != that.me.user_id)
            return true
        
          if (v == that.user.role)
            return true
        
          return 'You can\'t remove your own admin access.'
        }
      },
    },

    watch: {
      dialogVisible(visible) {
        if( visible) {
          if (this.user != null) {
            this.user_id = this.user.user_id,
            this.name = this.user.name
            this.display_name = this.user.display_name
            this.email = this.user.email
            this.phone = this.user.phone
            this.role = this.user.role
          } else {
            this.user_id = -1
            this.name = ''
            this.display_name = ''
            this.email = ''
            this.phone = ''
            this.role = 'user'
          }
        }
      },
    },

    methods: {
      ...mapActions('users', ['createUser', 'updateCurrentUser']),

      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        if (this.$refs.form.validate()) {
          
          const payload = {
            name: this.name,
            display_name: this.display_name,
            email: this.email,
            phone: this.phone,
            role: this.role,
          }
          this.loading = true
          let result
          if (this.user == null) {
            result = await this.createUser({ user_id: this.user_id, ...payload })
          } else {
            result = await this.updateCurrentUser({ user_id: this.user_id, ...payload })
          }
          this.loading=false

          if(result.ok) {
            this.close()
          } else {
            this.error_dialog = true
            this.error_message = result.error
          }
        }
      },

      // only populate the display name when creating a user
      onUpdateName() {
        if (this.user == null) {
          this.display_name = this.name.trim().split(' ')[0]
        }
      },

      onDisplayNameBlur() {
        if (this.display_name.trim() == '')
          this.display_name = this.name.trim().split(' ')[0]
      },
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>